var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinStackPath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 230,
    viewBox: "0 0 166 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "organize-yourself-path-left",
    id: "organize-yourself-path-left",
    d: "M83 0L83 75C83 78.3137 80.3137 81 77 80.9999L7 80.9999C3.68629 80.9999 0.999999 83.6862 0.999999 86.9999L0.99999 230",
    stroke: "#675F77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "organize-yourself-path-right",
    id: "organize-yourself-path-right",
    d: "M83 0L83 75.0001C83 78.3139 85.6863 81.0001 89 81.0001L159 81.0001C162.314 81.0001 165 83.6864 165 87.0001L165 200",
    stroke: "#675F77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinStackPath);
export default __webpack_public_path__ + "static/media/CoinStackPath.f729e6e57c8316f6ccc3c4d4de93568d.svg";
export { ForwardRef as ReactComponent };